export default __webpack_public_path__ + "static/media/stand_right hand.bae47a34.svg";